import {StateCreator} from 'zustand'

export interface PlayerInformationContainerPosition {
    x: number
    y: number
}

export interface PlayerInformationContainerSize {
    width: number
    height: number
}

export interface GamePortraitPlayerInformationLayoutSlice {
    /**
     * @deprecated Only use until UIMGamePlayerInformation is converted to ReactJS
     * This slice needs to exist because ReactJS sets the position of the player information container BUT PixiJS sets the size.
     */
    gamePortraitPlayerInformationLayout: {
        playerInformationContainerPosition: PlayerInformationContainerPosition | null
        setPlayerInformationContainerPosition: (position: PlayerInformationContainerPosition | null) => void
        playerInformationContainerSize: PlayerInformationContainerSize | null
        setPlayerInformationContainerSize: (size: PlayerInformationContainerSize | null) => void
    }
}

export const createGamePortraitPlayerInformationLayoutSlice = (): StateCreator<GamePortraitPlayerInformationLayoutSlice> => (set, get) => ({
    gamePortraitPlayerInformationLayout: {
        playerInformationContainerPosition: null,
        setPlayerInformationContainerPosition: (position: PlayerInformationContainerPosition | null) => {
            set({
                gamePortraitPlayerInformationLayout: {
                    ...get().gamePortraitPlayerInformationLayout,
                    playerInformationContainerPosition: position,
                },
            })
        },
        playerInformationContainerSize: null,
        setPlayerInformationContainerSize: (size: PlayerInformationContainerSize | null) => {
            set({
                gamePortraitPlayerInformationLayout: {
                    ...get().gamePortraitPlayerInformationLayout,
                    playerInformationContainerSize: size,
                },
            })
        },
    },
})
